import { useMemo } from 'react';

import { IRankFilterItem } from '../../types';

import { useBidFilterStore } from '../useBidFilterStore';

export const rankFiltersListConfig: IRankFilterItem[] = [
  {
    // rank: 'bidScreen.ranks.outOfQuantity', // TODO: Previous mobile translations
    filter: 'outOfQuantity',
    rankId: 'BID_QUANTITY_ZERO',
    status: 'out-of-qty',
    rank: 'out-of-qty',
    isSelected: false,
  },
  {
    filter: 'bidNotWinning',
    rankId: 'BID_OUT_OF_SUMMIT',
    status: 'out-of-summit',
    rank: 'not-winning',
    isSelected: false,
  },
  {
    filter: 'winningRange',
    rankId: 'BID_IN_SUMMIT',
    status: 'winning',
    rank: 'winning',
    isSelected: false,
  },
  {
    filter: 'noBids',
    rankId: 'NO_BIDS',
    status: 'no-bids',
    rank: 'no-bids',
    isSelected: false,
  },
  {
    filter: 'myBids',
    rankId: 'MY_BIDS',
    status: 'my-bids',
    rank: 'my-bids',
    isSelected: false,
  },
];

interface IUseRankFiltersConfig {
  rankFiltersConfig: IRankFilterItem[];
  selectedRank: IRankFilterItem | null;
}

/**
 * Custom hook to manage the state of the bids filter list
 */
export function useRankFiltersConfig(): IUseRankFiltersConfig {
  const { selectedBidRankFilter } = useBidFilterStore();

  const config = useMemo(() => {
    let selectedRank: IRankFilterItem | null = null;

    const rankFiltersConfig = rankFiltersListConfig.map((item) => {
      const isSelected = item.rankId === selectedBidRankFilter;
      const rank = item.rank;

      const configItem = { ...item, isSelected, rank };

      if (isSelected) {
        selectedRank = configItem;
      }

      return configItem;
    });

    return { rankFiltersConfig, selectedRank };
  }, [selectedBidRankFilter]);

  return config;
}
